import React from 'react';
import { Paper, Box } from '@mui/material';

const WidgetContainer = ({ children, elevation = 1 }) => {
  return (
    <Paper elevation={elevation} sx={{ borderRadius: '6px', height: '100%' }}>
      <Box sx={{ padding: 2 }}>{children}</Box>
    </Paper>
  );
};

export default WidgetContainer;
